export default "__VITE_ASSET__57c6cc33__"